import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormFieldContext } from '../form-field/form-field.context';

let nextUniqueId;
nextUniqueId = 0;

/**
 * @typedef Props
 * @prop {(event: React.SyntheticEvent) => void} [onChange]
 * @prop {(event: React.SyntheticEvent) => void} [onFocus]
 * @prop {(event: React.SyntheticEvent) => void} [onBlur]
 * @prop {string} [placeholder]
 * @prop {string} [value]
 * @prop {string} [className]
 * @prop {boolean} [disabled]
 * @prop {string} [id]
 * @prop {boolean} [required]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifTextArea = (props) => {
  const {
    className = '',
    disabled = false,
    id = '',
    required = false,
    onBlur = () => null,
    onChange = () => null,
    onFocus = () => null,
    value = '',
    placeholder = '',
    ...other
  } = props;
  const formFieldContext = useContext(FormFieldContext);

  useEffect(() => {
    formFieldContext.setRequired(required);
    formFieldContext.setDisabled(disabled);
    formFieldContext.setFormElementType('textInput');

    id ? formFieldContext.setId(id) : formFieldContext.setId(`motif-text-area-${nextUniqueId++}`);
  }, []);

  useEffect(() => {
    formFieldContext.setValue(value);
    formFieldContext.setHasContent(value.length > 0);
  }, [value]);

  const handleBlur = event => {
    formFieldContext.toggleFocus(event);
    onBlur(event);
  };

  const handleChange = event => {
    formFieldContext.setValue(event.target.value);
    onChange(event);
  };

  const handleFocus = event => {
    formFieldContext.toggleFocus(event);
    onFocus(event);
  };

  const classes = classNames({
    'motif-text-area': true,
    'motif-input-invalid': formFieldContext.invalid,
    [className]: true
  });

  return (
    <div className="motif-input-component" data-motif-text-area>
      <textarea
        {...other}
        id={formFieldContext.id}
        className={classes}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
      />
    </div>
  );
};

MotifTextArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  id: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string
};

export { MotifTextArea };
